export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a2332] via-[#2a4a5c] to-[#3a6a7c]">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8">
        <div className="max-w-4xl">
          <h1 className="text-7xl font-bold text-white leading-tight mb-8">
            Modern iOS Applications for Enhanced Security
          </h1>
          <p className="text-3xl text-white/80 font-light">
            VPN & Cleaner Solutions
          </p>
        </div>

        <div className="absolute bottom-32 left-8 right-8 flex gap-12">
          <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl p-10 max-w-sm">
            <h3 className="text-2xl font-semibold text-white mb-6">Enterprise-Grade VPN</h3>
            <ul className="space-y-3 text-white/70">
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>Military-grade encryption protocols</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>Lightning-fast connection speeds</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>Global server network coverage</span>
              </li>
            </ul>
          </div>

          <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl p-10 max-w-sm -mt-16">
            <h3 className="text-2xl font-semibold text-white mb-6">Intelligent Cleaner</h3>
            <ul className="space-y-3 text-white/70">
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>Advanced storage optimization</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>Privacy protection features</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-lg">•</span>
                <span>One-tap device enhancement</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
